// Types from shared schemas (single source of truth)
export type {
  Action,
  Possession,
  Resource,
  Role,
} from '@travel-planner/shared/schemas/auth';

// Const objects for dot-access (role.admin, resource.crm, action.read)
export const role = {
  admin: 'admin',
  operation: 'operation',
  consulting: 'consulting',
  external: 'external',
  content: 'content',
  finance: 'finance',
  superFinance: 'super_finance',
  system: 'system',
  marketingAdmin: 'marketing_admin',
  // Eleggia DMC Partner Profile roles.
  hqAdmin: 'hq_admin',
  hqFinanceLegal: 'hq_finance_legal',
  dmcPrincipal: 'dmc_principal',
  dmcEditor: 'dmc_editor',
  consortiumMember: 'consortium_member',
} as const;

export const resource = {
  dashboard: 'dashboard',
  itineraries: 'itineraries',
  products: 'products',
  operations: 'operations',
  crm: 'crm',
  inbox: 'inbox',
  tasks: 'tasks',
  incidents: 'incidents',
  supportTickets: 'support_tickets',
  userSettings: 'user_settings',
  companySettings: 'company_settings',
  dmcProfile: 'dmc_profile',
  recommendation: 'recommendation',
  agentPanel: 'agent-panel',
  accounts: 'accounts',
  whatsappMessages: 'whatsapp_messages',
  systemBrief: 'system_brief',
  paymentLogs: 'payment_logs',
  marketing: 'marketing',
} as const;

export const action = {
  create: 'create',
  read: 'read',
  update: 'update',
  delete: 'delete',
  use: 'use',
} as const;
